<mat-toolbar *ngIf="show" class="announcement-toolbar">
    <mat-toolbar-row class="announcement-toolbar-row">
        <mat-icon class="announcement-toolbar-icon" svgIcon="ui-warning" *ngIf="displayWarningIcon"></mat-icon>
        <span class="announcement-toolbar-text">{{title}}</span>
        <button class="announcement-toolbar-link" i18n="Announcement button read more|Read more" mat-button color="primary" (click)="readMore()">Read more</button>
    </mat-toolbar-row>
</mat-toolbar>
